//app global configuration

const Config: any = {};

export default Config;
